import React from 'react';
import moment from 'moment';
import {
  ChatsWhatsappCellEllipsis,
  ChatsWhatsappRow,
  ChatsWhatsappTdAtualizado,
  ChatsWhatsappTdContato,
  ChatsWhatsappTdCorretor,
  ChatsWhatsappTdMsgs,
  ChatsWhatsappTdSolicitacao,
  ChatsWhatsappTdStatus,
  ChatsWhatsappTdTelefone,
  ChatsWhatsappTdUltimaMsg,
  ChatsWhatsappTdUltimaMsgData,
} from './chatsWhatsappTable.styles';
import { ConversationStatusBadge } from './chatsWhatsapp.styles';
import RequestTableToolTip from '../../../components/Operational/table/RequestTableToolTip';

const STATUS_LABELS = {
  lucia: 'Em andamento',
  finalizado: 'Finalizado',
  suspenso: 'Suspenso',
};

const statusLabel = (status) => STATUS_LABELS[status] || '—';

const getApplicantNames = (pretendentes) =>
  Array.isArray(pretendentes)
    ? pretendentes
        .map((pretendente) => {
          if (typeof pretendente === 'string') return pretendente;
          if (!pretendente) return '';
          if (Boolean(pretendente.oculto)) return 'IDENTIFICAÇÃO OCULTADA';
          return pretendente.nome || pretendente.razao_social || '';
        })
        .filter(Boolean)
    : [];

const getApplicantDocs = (pretendentes) =>
  Array.isArray(pretendentes)
    ? pretendentes.map((pretendente) => {
        if (!pretendente || typeof pretendente === 'string') return '';
        if (Boolean(pretendente.oculto)) return 'OCULTADO';
        return pretendente.documento || pretendente.cpf || pretendente.cnpj || '';
      })
    : [];

const getProperty = (line) => {
  const codigo = line.codigo_imovel != null ? String(line.codigo_imovel).trim() : '';
  const endereco = line.endereco != null ? String(line.endereco).trim() : '';
  return [codigo, endereco].filter(Boolean).join(' / ') || '—';
};

const ChatWhatsappTableRow = ({
  line,
  selected,
  onRowClick,
  showTelefoneColumn = true,
  chatTipo = 'coleta',
  index = 0,
  length = 1,
}) => {
  const pretendente = line.pretendente_nome || '—';
  const phone = line.pretendente_telefone || line.whatsapp_from || '—';
  const usuarioImobiliaria = line.usuario_imobiliaria || '—';
  const solicitacao = line.solicitacao_id || '—';
  const preview = line.last_message_preview || '—';
  const updated =
    line.updated_at != null ? moment(line.updated_at).format('DD/MM/YYYY HH:mm') : '—';
  const status = line.status || null;

  if (chatTipo === 'solicita') {
    const applicantNames = getApplicantNames(line.pretendentes);
    const applicantDocs = getApplicantDocs(line.pretendentes);
    const firstApplicant = applicantNames[0] || '—';
    const property = getProperty(line);
    const lastMessageAt = line.last_message_at || line.updated_at;
    const lastMessageDate =
      lastMessageAt != null ? moment(lastMessageAt).format('DD/MM/YYYY HH:mm') : '—';

    return (
      <ChatsWhatsappRow
        onClick={() => onRowClick(line)}
        role="button"
        tabIndex={0}
        style={{
          background: selected ? '#eff6ff' : undefined,
        }}
      >
        <ChatsWhatsappTdSolicitacao>{solicitacao}</ChatsWhatsappTdSolicitacao>
        <ChatsWhatsappTdCorretor>
          <ChatsWhatsappCellEllipsis
            title={usuarioImobiliaria !== '—' ? usuarioImobiliaria : undefined}
          >
            {usuarioImobiliaria}
          </ChatsWhatsappCellEllipsis>
        </ChatsWhatsappTdCorretor>
        <ChatsWhatsappTdUltimaMsg>
          <ChatsWhatsappCellEllipsis title={property !== '—' ? property : undefined}>
            {property}
          </ChatsWhatsappCellEllipsis>
        </ChatsWhatsappTdUltimaMsg>
        <ChatsWhatsappTdContato>
          {applicantNames.length > 0 ? (
            <RequestTableToolTip
              message={applicantNames}
              extraData={applicantDocs}
              index={index}
              length={length}
              type="applicantName"
            >
              <ChatsWhatsappCellEllipsis>{firstApplicant}</ChatsWhatsappCellEllipsis>
            </RequestTableToolTip>
          ) : (
            firstApplicant
          )}
        </ChatsWhatsappTdContato>
        <ChatsWhatsappTdMsgs>
          {line.messages_count != null ? String(line.messages_count) : '0'}
        </ChatsWhatsappTdMsgs>
        <ChatsWhatsappTdUltimaMsgData>{lastMessageDate}</ChatsWhatsappTdUltimaMsgData>
        <ChatsWhatsappTdStatus>
          <ConversationStatusBadge $status={status}>
            {statusLabel(status)}
          </ConversationStatusBadge>
        </ChatsWhatsappTdStatus>
      </ChatsWhatsappRow>
    );
  }

  return (
    <ChatsWhatsappRow
      onClick={() => onRowClick(line)}
      role="button"
      tabIndex={0}
      style={{
        background: selected ? '#eff6ff' : undefined,
      }}
    >
      <ChatsWhatsappTdContato>
        <ChatsWhatsappCellEllipsis title={pretendente !== '—' ? pretendente : undefined}>
          {pretendente}
        </ChatsWhatsappCellEllipsis>
      </ChatsWhatsappTdContato>
      {showTelefoneColumn && (
        <ChatsWhatsappTdTelefone>
          <ChatsWhatsappCellEllipsis title={phone !== '—' ? phone : undefined}>
            {phone}
          </ChatsWhatsappCellEllipsis>
        </ChatsWhatsappTdTelefone>
      )}
      <ChatsWhatsappTdCorretor>
        <ChatsWhatsappCellEllipsis title={usuarioImobiliaria !== '—' ? usuarioImobiliaria : undefined}>
          {usuarioImobiliaria}
        </ChatsWhatsappCellEllipsis>
      </ChatsWhatsappTdCorretor>
      <ChatsWhatsappTdSolicitacao>
        <ChatsWhatsappCellEllipsis title={solicitacao !== '—' ? String(solicitacao) : undefined}>
          {solicitacao}
        </ChatsWhatsappCellEllipsis>
      </ChatsWhatsappTdSolicitacao>
      <ChatsWhatsappTdUltimaMsg>
        <ChatsWhatsappCellEllipsis title={preview !== '—' ? preview : undefined}>
          {preview}
        </ChatsWhatsappCellEllipsis>
      </ChatsWhatsappTdUltimaMsg>
      <ChatsWhatsappTdMsgs>
        {line.messages_count != null ? String(line.messages_count) : '0'}
      </ChatsWhatsappTdMsgs>
      <ChatsWhatsappTdAtualizado>
        <ChatsWhatsappCellEllipsis title={updated !== '—' ? updated : undefined}>
          {updated}
        </ChatsWhatsappCellEllipsis>
      </ChatsWhatsappTdAtualizado>
      <ChatsWhatsappTdStatus>
        <ConversationStatusBadge $status={status}>
          {statusLabel(status)}
        </ConversationStatusBadge>
      </ChatsWhatsappTdStatus>
    </ChatsWhatsappRow>
  );
};

export default ChatWhatsappTableRow;
